import type { FC } from 'react';
import React, { useContext, useMemo, useState } from 'react';

import { EditorContext, RicosContext, ToolbarContext } from './../../../ricos-context';

import { MaxWidthCalculationWrapper } from '../../components/MaxWidthCalculationWrapper/MaxWidthCalculationWrapper';
import { Toolbar } from '../../components/Toolbar';
import { FORMATTING_TOOLBAR } from './data-hooks';

type Props = {
  maxWidth?: number;
};

export const FormattingToolbar: FC<Props> = ({ maxWidth }) => {
  const {
    adapter: { tiptapEditor },
  } = useContext(EditorContext);
  const { toolbars } = useContext(ToolbarContext);
  const { isMobile } = useContext(RicosContext);
  const toolbarItemsConfig = useMemo(() => toolbars.formatting.getToolbarItemsConfig(), []);
  const toolbarItemsRenderers = toolbars.formatting.getToolbarItemsRenderers();
  const [toolbarMaxWidth, setToolbarMaxWidth] = useState(
    typeof maxWidth === 'number' ? maxWidth : tiptapEditor.view.dom.clientWidth
  );

  const isFormattingToolbarEmpty = toolbars.formatting.isEmpty();

  if (isFormattingToolbarEmpty) {
    return null;
  }

  return (
    <MaxWidthCalculationWrapper
      setMaxWidth={setToolbarMaxWidth}
      style={{ maxWidth: 'fit-content' }}
      data-hook={FORMATTING_TOOLBAR}
    >
      <Toolbar
        type="floating"
        isMobile={isMobile}
        toolbarItemsConfig={toolbarItemsConfig}
        toolbarItemsRenderers={toolbarItemsRenderers}
        maxWidth={toolbarMaxWidth}
      />
    </MaxWidthCalculationWrapper>
  );
};
